import React from 'react';
import { Instagram } from 'lucide-react';

// Placeholder grid — swap `image` for real Instagram post exports and
// `href` for the real post permalinks once the client supplies them.
const POSTS = [
  { image: 'https://images.unsplash.com/photo-1543294001-f7cd5d7fb516?crop=entropy&cs=srgb&fm=jpg&w=600&q=85', href: 'https://instagram.com' },
  { image: 'https://images.unsplash.com/photo-1624588057318-5f1b2eb81012?crop=entropy&cs=srgb&fm=jpg&w=600&q=85', href: 'https://instagram.com' },
  { image: 'https://images.pexels.com/photos/5370644/pexels-photo-5370644.jpeg?auto=compress&cs=tinysrgb&w=600', href: 'https://instagram.com' },
  { image: 'https://images.unsplash.com/photo-1693212793204-bcea856c75fe?crop=entropy&cs=srgb&fm=jpg&w=600&q=85', href: 'https://instagram.com' },
  { image: 'https://images.pexels.com/photos/20838859/pexels-photo-20838859.jpeg?auto=compress&cs=tinysrgb&w=600', href: 'https://instagram.com' },
  { image: 'https://images.unsplash.com/photo-1573408301185-9146fe634ad0?crop=entropy&cs=srgb&fm=jpg&w=600&q=85', href: 'https://instagram.com' }
];

const InstagramFeed = () => (
  <section className="py-8 lg:py-10 bg-[#FFFFFF]">
    <div className="max-w-[1500px] mx-auto px-6 lg:px-10">
      <div className="text-center mb-10">
        <h2 className="font-serif text-3xl lg:text-4xl text-[#1a1a1a] flex items-center justify-center gap-3 whitespace-nowrap">
          <Instagram size={22} strokeWidth={1.4} className="flex-shrink-0" /> @houseofseya
        </h2>
      </div>
      <div className="grid grid-cols-3 lg:grid-cols-6 gap-2 lg:gap-3">
        {POSTS.map((p, i) => (
          <a key={i} href={p.href} target="_blank" rel="noopener noreferrer" className="group block aspect-square overflow-hidden bg-[#FFFFFF]">
            <img src={p.image} alt="Instagram post" className="w-full h-full object-cover transition-transform duration-[900ms] group-hover:scale-105" />
          </a>
        ))}
      </div>
    </div>
  </section>
);

export default InstagramFeed;
